var Will = {
    REMOVE_TOPICS : 0
};

function TopicWillParameters(path, will) {
    this.path = path;
    this.will = will;
}

TopicWillParameters.prototype.toString = function() {
    return "TopicWillParams [" + this.will + ", " + this.path + "]";  
};

TopicWillParameters.Will = Will;

module.exports = TopicWillParameters;


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/wills/topic-will-parameters.js
// module id = 210
// module chunks = 0